import { useState } from "react";
import { login } from "../api";

const SAMPLE_CREDS = [
  { role: "admin",   email: "admin@company.com",       password: "Admin@2026",  name: "Admin User"                   },
  { role: "admin",   email: "governance@company.com",  password: "Gov@2026",    name: "Governance Manager"            },
  { role: "manager", email: "alex.rivera@company.com", password: "Alex@2026",   name: "Alex Rivera (Engineering)"     },
  { role: "manager", email: "priya.nair@company.com",  password: "Priya@2026",  name: "Priya Nair (Data Science)"     },
  { role: "manager", email: "sam.patel@company.com",   password: "Sam@2026",    name: "Sam Patel (Customer Support)"  },
  { role: "user",    email: "alice@company.com",       password: "Alice@123",   name: "Alice Johnson"                 },
  { role: "user",    email: "bob@company.com",         password: "Bob@123",     name: "Bob Smith"                     },
  { role: "user",    email: "carol@company.com",       password: "Carol@123",   name: "Carol Davis"                   },
];

// M+ logo as SVG matching the provided brand mark
function MplusLogo() {
  return (
    <svg width="80" height="50" viewBox="0 0 80 50" xmlns="http://www.w3.org/2000/svg">
      <text
        x="0" y="44"
        fontFamily="'Inter', Arial Black, system-ui, sans-serif"
        fontWeight="900"
        fontSize="46"
        fill="white"
      >M+</text>
    </svg>
  );
}

function QuickFill({ roleFilter, onFill }) {
  const [open, setOpen] = useState(false);
  const creds = SAMPLE_CREDS.filter((c) =>
    roleFilter === "admin" ? c.role === "admin" : c.role !== "admin"
  );
  return (
    <div style={{ marginTop: 20 }}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        style={{
          width: "100%", padding: "8px 14px",
          borderRadius: 7, border: "1px dashed #d1d5db",
          background: "none", cursor: "pointer",
          fontSize: 12, fontWeight: 600,
          color: "#9ca3af",
          display: "flex", alignItems: "center", justifyContent: "center", gap: 6,
        }}>
        Demo credentials {open ? "▲" : "▾"}
      </button>

      {open && (
        <div style={{ marginTop: 10, borderRadius: 8, border: "1px solid #e5e7eb", overflow: "hidden", fontSize: 12 }}>
          <div style={{
            display: "grid", gridTemplateColumns: "70px 1fr 1fr",
            padding: "6px 12px", background: "#f9fafb",
            fontWeight: 700, color: "#9ca3af", textTransform: "uppercase",
            letterSpacing: "0.06em", fontSize: 10,
            borderBottom: "1px solid #e5e7eb",
          }}>
            <span>Role</span><span>Email</span><span>Password</span>
          </div>

          {creds.map((c) => (
            <div
              key={c.email}
              onClick={() => { onFill(c.email, c.password); setOpen(false); }}
              style={{
                display: "grid", gridTemplateColumns: "70px 1fr 1fr",
                padding: "9px 12px", cursor: "pointer",
                borderBottom: "1px solid #e5e7eb",
                transition: "background .1s", alignItems: "center",
              }}
              onMouseEnter={(e) => e.currentTarget.style.background = "#eff6ff"}
              onMouseLeave={(e) => e.currentTarget.style.background = ""}
            >
              <span style={{
                display: "inline-block",
                fontSize: 10, fontWeight: 700, padding: "2px 6px", borderRadius: 4,
                background: c.role === "admin" ? "#fee2e2" : c.role === "manager" ? "#fef3c7" : "#eff6ff",
                color:      c.role === "admin" ? "#b91c1c" : c.role === "manager" ? "#92400e" : "#1d4ed8",
              }}>
                {c.role.toUpperCase()}
              </span>
              <span style={{ color: "#111827", fontFamily: "monospace", fontSize: 11 }}>{c.email}</span>
              <span style={{ color: "#6b7280", fontFamily: "monospace", fontSize: 11 }}>{c.password}</span>
            </div>
          ))}

          <div style={{ padding: "7px 12px", background: "#f9fafb", color: "#9ca3af", fontSize: 11 }}>
            Click any row to auto-fill
          </div>
        </div>
      )}
    </div>
  );
}

// ── Role selection card ───────────────────────────────────────────────────────
function RoleCard({ icon, title, subtitle, onClick }) {
  const [hovered, setHovered] = useState(false);
  return (
    <button
      type="button"
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        flex: 1,
        display: "flex", flexDirection: "column", alignItems: "center",
        gap: 10, padding: "28px 16px",
        borderRadius: 12,
        border: hovered ? "2px solid #2563eb" : "2px solid #e5e7eb",
        background: hovered ? "#eff6ff" : "#ffffff",
        cursor: "pointer",
        transition: "border-color .15s, background .15s, box-shadow .15s",
        boxShadow: hovered ? "0 0 0 4px rgba(37,99,235,0.10)" : "0 1px 3px rgba(0,0,0,0.07)",
      }}>
      <div style={{
        width: 48, height: 48, borderRadius: 12,
        background: hovered ? "#2563eb" : "#f3f4f6",
        display: "flex", alignItems: "center", justifyContent: "center",
        transition: "background .15s",
      }}>
        {icon(hovered)}
      </div>
      <div style={{ textAlign: "center" }}>
        <div style={{ fontWeight: 700, fontSize: 15, color: "#111827" }}>{title}</div>
        <div style={{ fontSize: 12, color: "#6b7280", marginTop: 3 }}>{subtitle}</div>
      </div>
    </button>
  );
}

const UserIcon = (active) => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={active ? "#fff" : "#6b7280"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
  </svg>
);

const AdminIcon = (active) => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={active ? "#fff" : "#6b7280"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
  </svg>
);

// ── Main Login component ──────────────────────────────────────────────────────
export default function Login({ onLogin }) {
  const [step,     setStep]     = useState("role");  // "role" | "login"
  const [roleMode, setRoleMode] = useState(null);    // "user" | "admin"
  const [email,    setEmail]    = useState("");
  const [password, setPassword] = useState("");
  const [error,    setError]    = useState("");
  const [busy,     setBusy]     = useState(false);

  const pickRole = (mode) => {
    setRoleMode(mode);
    setEmail("");
    setPassword("");
    setError("");
    setStep("login");
  };

  const goBack = () => {
    setStep("role");
    setRoleMode(null);
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!email.trim() || !password)
      return setError("Please enter your email and password.");
    setBusy(true);
    try {
      const user = await login(email.trim(), password);
      // Enforce role match
      const isAdmin = user.role === "admin";
      if (roleMode === "admin" && !isAdmin)
        throw new Error("This account does not have admin access.");
      if (roleMode === "user" && isAdmin)
        throw new Error("Please use the Admin portal to sign in.");
      onLogin(user);
    } catch (err) {
      setError(err.message || "Invalid email or password.");
    } finally {
      setBusy(false);
    }
  };

  const quickFill = (e, p) => { setEmail(e); setPassword(p); setError(""); };

  // ── Shared branding header ────────────────────────────────────────────────
  const Branding = () => (
    <div style={{ textAlign: "center", marginBottom: 36 }}>
      <div style={{ marginBottom: 16 }}>
        <MplusLogo />
      </div>
      <h1 style={{ fontSize: 24, fontWeight: 800, letterSpacing: "-0.5px", margin: 0, color: "#ffffff" }}>
        AI Governance
      </h1>
      <p style={{ color: "rgba(255,255,255,0.5)", fontSize: 14, marginTop: 5 }}>
        Request &amp; Model Control
      </p>
    </div>
  );

  // ── Role selection ────────────────────────────────────────────────────────
  if (step === "role") {
    return (
      <div style={{ width: "100%", maxWidth: 480, padding: "24px" }}>
        <Branding />

        <div style={{
          background: "#ffffff", borderRadius: 16,
          boxShadow: "0 4px 32px rgba(0,0,0,0.28)",
          overflow: "hidden",
        }}>
          <div style={{
            padding: "20px 24px 16px",
            borderBottom: "1px solid #f3f4f6",
            textAlign: "center",
          }}>
            <div style={{ fontWeight: 700, fontSize: 17, color: "#111827" }}>Sign In</div>
            <div style={{ fontSize: 13, color: "#6b7280", marginTop: 3 }}>
              Choose your access type to continue
            </div>
          </div>

          <div style={{ padding: "24px", display: "flex", gap: 14 }}>
            <RoleCard
              icon={UserIcon}
              title="User"
              subtitle="Employees & Managers"
              onClick={() => pickRole("user")}
            />
            <RoleCard
              icon={AdminIcon}
              title="Admin"
              subtitle="Platform Administrators"
              onClick={() => pickRole("admin")}
            />
          </div>
        </div>

        <p style={{ textAlign: "center", fontSize: 12, color: "rgba(255,255,255,0.3)", marginTop: 20 }}>
          AI Governance Platform · Internal Use Only
        </p>
      </div>
    );
  }

  // ── Login form ────────────────────────────────────────────────────────────
  const roleMeta = roleMode === "admin"
    ? { label: "Admin", color: "#b91c1c", bg: "#fee2e2" }
    : { label: "User",  color: "#1d4ed8", bg: "#eff6ff" };

  return (
    <div style={{ width: "100%", maxWidth: 440, padding: "24px" }}>
      <Branding />

      <div style={{
        background: "#ffffff", borderRadius: 16,
        boxShadow: "0 4px 32px rgba(0,0,0,0.28)",
        overflow: "hidden",
      }}>
        {/* Card header with back + role badge */}
        <div style={{
          display: "flex", alignItems: "center", justifyContent: "space-between",
          padding: "16px 20px",
          borderBottom: "1px solid #f3f4f6",
          background: "#f9fafb",
        }}>
          <button
            type="button"
            onClick={goBack}
            style={{
              background: "none", border: "none", cursor: "pointer",
              display: "flex", alignItems: "center", gap: 6,
              fontSize: 13, fontWeight: 600, color: "#6b7280",
              padding: "4px 0",
            }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="15 18 9 12 15 6"/>
            </svg>
            Back
          </button>
          <span style={{
            fontSize: 11, fontWeight: 700, padding: "3px 9px", borderRadius: 5,
            background: roleMeta.bg, color: roleMeta.color, textTransform: "uppercase",
            letterSpacing: "0.06em",
          }}>
            {roleMeta.label} Login
          </span>
        </div>

        <div style={{ padding: "24px" }}>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                placeholder="you@company.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoFocus
                required
                autoComplete="username"
              />
            </div>
            <div className="form-group">
              <label>Password</label>
              <input
                type="password"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
              />
            </div>

            {error && (
              <div className="error-msg" style={{ marginBottom: 12 }}>{error}</div>
            )}

            <button className="btn btn-primary" type="submit" disabled={busy} style={{ width: "100%", marginTop: 4 }}>
              {busy ? "Signing in…" : "Sign In →"}
            </button>
          </form>

          <QuickFill roleFilter={roleMode} onFill={quickFill} />
        </div>
      </div>

      <p style={{ textAlign: "center", fontSize: 12, color: "rgba(255,255,255,0.3)", marginTop: 20 }}>
        AI Governance Platform · Internal Use Only
      </p>
    </div>
  );
}
